import { useSelector } from "react-redux";
import StudentTicketDashboard from "../StudentTicketDashboard/StudentTicketDashboard";
import SupportTicketDashboard from "../SupportTicketDashboard/SupportTicketDashboard";

import Login from "../../../User/components/LoginPage/Login";
import AdminDashboards from "../../../User/components/AdminDashboards/AdminDashboards";

export default function LandingPageTickets() {
  const isLoggedIn = useSelector((state) => state.user.isAuthenticated);
  const user = useSelector((state) => state.user.user);

  const roles = user?.roles?.map(r => r.authority) || [];

  const hasRole = (roleName) => roles.includes(roleName);

  if (!isLoggedIn) {
    return (
      <div data-testid="LandingPage" style={{height: "100%"}}>
        <Login />
      </div>
    );
  }

  return (
    <>
      {/* if logged in show dashboard otherwise show login page */}
       
      <div data-testid="LandingPage" style={{height: "100%"}}>
      <main className="App-main" data-testid="App-main" style={{height: "100%"}}>
        {hasRole("ROLE_STUDENT")? (
          <StudentTicketDashboard />
        ) : (hasRole("ROLE_SUPPORT") || hasRole("ROLE_TECHNOLOGY")) ? (
          <SupportTicketDashboard />
        ) : hasRole("ROLE_ADMIN") ? (
          <AdminDashboards />
        ) : null }
      </main>
      </div>
    </>
        
  );
}
 